<template>
  <table class="table table-striped text-center">
    <thead>
    <tr>
      <th scope="col" width="15%">Template</th>
      <th scope="col" width="5%">Prioridad</th>
      <th scope="col" width="35%" >Reglas</th>
      <th scope="col">Descripci&oacute;n</th>
      <th scope="col" width="7%">Activado</th>
      <th scope="col" width="7%">Modificar</th>
      <th scope="col" width="7%">Eliminar</th>
    </tr>
    </thead>
    <tbody>
      <rules-sets-table-row
              v-for="rulesSet in rulesSets"
              :rulesSet="rulesSet"
              :key="rulesSet.id"
              @error="onComponentError"
              @success="onComponentSuccess"
      />
    </tbody>
  </table>
</template>

<script>

import RulesSetsTableRow from '@/components/RulesSetsTableRow.vue'

export default {
    name: 'rules-sets-table',
    components: {
      'rules-sets-table-row' : RulesSetsTableRow
    },
    props: ['rulesSets'],
    methods : {
        onComponentError (message) {
            this.$emit('error', message);
        },
        onComponentSuccess (message) {
            this.$emit('success', message);
        }
    }
}
</script>

<style>
  .table {
  margin: auto;
  width: 90% !important;
  }
</style>
